import JoyButton, { ButtonProps } from '@mui/joy/Button';

const Button = ({ children, ...rest }: ButtonProps) => {
  return <JoyButton {...rest}>{children}</JoyButton>;
};

export default Button;
